var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maincont",style:({ width: _vm.width + 'px' , gap:_vm.Gap + 'px'})},[_c('div',{staticClass:"linear-progress-container",style:({ height: _vm.Containerheight + 'px', backgroundColor: _vm.trackColor })},[_c('div',{staticClass:"linear-progress-bar",style:({
        width: _vm.currentPercentage + '%',
        backgroundColor: _vm.progressColor,
        height: _vm.height + 'px',
        transition: 'width 0.5s ease'
      })})]),_c('div',{staticClass:"linear-progress-texts",style:({ fontSize: _vm.fontSize + 'px', color: _vm.color })},[_vm._v(" "+_vm._s(_vm.currentPercentage)+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }